import React from 'react'
import { observer } from 'mobx-react-lite'
import { Live } from 'models/live'

interface CardProps {
  item: Live
  onPress: () => void
}

const Card = (props: CardProps) => {
  return (
    <div
      onClick={props.onPress}
      className="relative my-6 overflow-hidden rounded-md shadow-md cursor-pointer"
    >
      <div
        className="aspect-w-16 aspect-h-9 bg-cover bg-center bg-norepeat"
        style={{ backgroundImage: `url(${props.item.image})` }}
      >
        <div className="absolute bg-gradient-to-br from-black to-transparent" />
        <div className="flex p-6 items-start">
          <h1 className="text-md font-semibold text-white truncate uppercase">
            {props.item.title}
          </h1>
        </div>
      </div>
    </div>
  )
}

export default observer(Card)
